(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clinical-stats-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rw-count-up')) {
    customElements.define(
      'rw-count-up',
      class RwCountUp extends HTMLElement {
        connectedCallback() {
          this.target = parseFloat(this.dataset.target);
          this.suffix = this.dataset.suffix || '';
          this.duration = parseInt(this.dataset.duration, 10) || 1800;

          if (isNaN(this.target)) return;

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduceMotion) {
            this.render(this.target);
            return;
          }

          this.render(0);
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  this.animate();
                  this.observer.disconnect();
                }
              });
            },
            { threshold: 0.4 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        render(value) {
          this.textContent = Math.round(value) + this.suffix;
        }

        animate() {
          const start = performance.now();
          const step = (now) => {
            const progress = Math.min((now - start) / this.duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            this.render(eased * this.target);
            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              this.render(this.target);
            }
          };
          requestAnimationFrame(step);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
